module.exports = __webpack_public_path__ + "CriticalTreasures.jpg?61473c67d3ebe2a09d6f98434e6a992a";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/CriticalTreasures.jpg
// module id = 459
// module chunks = 0